import { IChangeListItemLocationProps } from "./ChangeListItemTypes"

import { Text, Flex } from "@chakra-ui/react"
import MapButton from "components/UI/molecules/MapButton"
import GoogleMapModal from "components/shared/modals/GoogleMapModal"
import { useUI } from "providers/UIProvider"

const ChangeListItemLocation: React.FC<IChangeListItemLocationProps> = ({ title, lat, lng, isCurrent }) => {

  const { toggleModal } = useUI()

  const coords = { lat: parseFloat(lat), lng: parseFloat(lng) }

  return (
    <>
      <Text mb={"8px"} fontSize="base">
        {title}
      </Text>
      <Flex padding={"16px"} borderRadius={"10px"} align={"center"} justifyContent="center" bgColor={"#fff"}>
        <Text fontSize="base" fontWeight={600} mr="20px">{lat}, {lng}</Text>
        <MapButton onClick={() => isCurrent ? toggleModal("googleMapModal", true) : toggleModal("myGoogleMapsModal", true)} />
        <GoogleMapModal coordinates={coords} />
      </Flex>
    </>
  )
}

export default ChangeListItemLocation